import React, { useEffect, useState, useRef, useCallback } from "react";

export function MouseGlow() {
  const [pos, setPos] = useState({ x: -200, y: -200 });
  const rafRef = useRef(0);

  const handleMouseMove = useCallback((e) => {
    cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => {
      setPos({ x: e.clientX, y: e.clientY });
    });
  }, []);

  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove, { passive: true });
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      cancelAnimationFrame(rafRef.current);
    };
  }, [handleMouseMove]);

  return (
    <div
      className="fixed pointer-events-none z-[1]"
      style={{
        left: pos.x - 200,
        top: pos.y - 200,
        width: 400,
        height: 400,
        background: "radial-gradient(circle, oklch(0.8 0.08 280 / 0.08) 0%, oklch(0.75 0.06 160 / 0.04) 40%, transparent 70%)",
        transition: "left 0.15s ease-out, top 0.15s ease-out",
        borderRadius: "50%",
      }}
    />
  );
}
